import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

    static targets() {
        return ['tab', 'content'];
    }

    connect() {
        this.targets.findAll('tab').forEach((tab) => {
            tab.addEventListener('click', () => {
                const expanded = tab.classList && tab.classList.contains('tab-open');
                const id = tab.getAttribute('data-tabs-open');
                if (expanded) {
                    tab.classList.remove('tab-open');
                } else {
                    tab.classList.add('tab-open');
                }

                this.toggleTarget(expanded, id);

                this.targets.findAll('tab').forEach((tab2) => {
                    if (tab2.getAttribute('data-tabs-open') !== id) {
                        tab2.classList.remove('tab-open');
                    }
                });
            });
        });

        this.targets.findAll('content').forEach((target) => {
            if (target.classList && target.classList.contains('tab-open')) {
                this.toggleTarget(false, target.id);
            }
        });
    }

    toggleTarget(expanded = false, id = '') {
        this.targets.findAll('content').forEach((target) => {
            if (target.id === id) {
                let totalChildrenHeight = 0;
                if (!expanded) {
                    for (const child of target.children) {
                        totalChildrenHeight += child.offsetHeight;
                        const computeStyle = window.getComputedStyle(child);
                        totalChildrenHeight += parseInt(computeStyle.getPropertyValue('margin-top'));
                        totalChildrenHeight += parseInt(computeStyle.getPropertyValue('margin-bottom'));
                    }
                }
                target.style.height = `max-content`;
                target.style.minHeight = `${totalChildrenHeight}px`;

                if (expanded) {
                    target.classList.remove('tab-open');
                } else {
                    target.classList.add('tab-open');
                }
            } else {
                target.classList.remove('tab-open');
                target.style.height = `0px`;
                target.style.minHeight = `0px`;
            }
        });
    }
}
